import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, keyify} from "../common";
import * as common from "../styles/common.module.scss";

function mapFieldNames(fieldName: string): string {
    switch(fieldName) {
        case "unitCount":
            return "Unit Count";
        case "leaseExpirationCount":
            return "Lease Expirations";
        case "averageMarketRent":
            return "Market Rent";
        case "earlyTerminationCount":
            return "Early Terminations";
        case "monthToMonthMoveOutCount":
            return "MTM Move Outs";
        case "moveOutRate":
            return "Move Outs";
        case "occupancyRate":
            return "Occupancy";
        case "renewalRate":
            return "Renewal Trade Out";
        case "renewalRatio":
            return "Renewals";
        case "newLeaseTradeOut":
            return "New Lease Trade Out";
        default:
            return "-----UNMAPPED NAME-----";
    }
}

function percentageNeedsMultiplication(fieldName: string): boolean {
    switch(fieldName) {
        case "occupancyRate":
        case "moveOutRate":
        case "renewalRatio":
            return true;
        default:
            return false;
    }
}

export function RenderUpsertUnitTypeScheduleValues(props: RendererProps): ReactElement {
    const fieldName = props.variables["fieldName"];
    const values = props.variables["values"];

    if(!fieldName || !Array.isArray(values)) {
        return <></>;
    }

    if(values.length === 0) {
        return <div>No Change</div>;
    }

    const multFactor = percentageNeedsMultiplication(fieldName) ? 100 : 1;
    const items: ReactElement[] = [];
    for(const item of values) {
        if(typeof item === "object") {
            let value = item["value"];
            let month = item["monthIndex"];
            const name = item["unitTypeName"];

            if(typeof month === "number") {
                month++;
            }

            if(typeof value === "number") {
                value *= multFactor;
            }

            if(value && month && name) {
                items.push(
                    <li key={keyify(month)}>
                        {ensureNotObject(name)} month {ensureNotObject(month)}: {ensureNotObject(value)}
                    </li>
                );
            }
        }
    }

    return <div>
        <div className={common.textSubHeader}>{mapFieldNames(fieldName)}</div>
        {items.length > 0 &&
            <ul>
                {items}
            </ul>
        }
    </div>;
}